import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'currentState',
  namespaced: true,
  state: {
    destinationState: '',
    editMode: '',
    flow: [],
    navAction: '',
    stateName: '',
    userIndex: '',
  },
  getters: {
    getField,
    currentState: (state) => state,
  },
  mutations: {
    updateField,
  },
};
